<ins-creator-action-panel
  [title]="panelTitle()"
  [subtitle]="panelSubtitle()"
  [warning]="!creatorHasRequiredPlatform()"
  [(expanded)]="expanded">
  @if (approvedVideos().length === 0) {
    <app-empty-state
      title="No approved videos"
      description="Get videos approved before posting on social." />
  } @else {
    @if (!creatorHasRequiredPlatform()) {
      <p class="mb-4 mt-0 text-sm text-red-700 dark:text-red-300" role="alert">
        No connected {{ getSocialChannelLabel(resolvedPlatform()) }} handle on this profile.
        You can still paste a post link and ad code.
      </p>
    }
    <ul class="m-0 flex list-none flex-col gap-4 divide-y divide-border p-0">
      @for (video of approvedVideos(); track video.id) {
        <li class="flex flex-col gap-4 pt-4 first:pt-0">
          <div class="flex gap-3">
            <div class="w-16 shrink-0 overflow-hidden rounded-lg">
              <atom-video-thumbnail
                [videoId]="video.id"
                [videoUrl]="video.fullUrl"
                [videoFormat]="video.videoFormat"
                [thumbnailURL]="video.thumbnailURL ?? undefined"
                [cdnKey]="video.thumbnailCdnKey ?? undefined"
                thumb_cdn_size="gallery_sm" />
            </div>
            <div class="min-w-0">
              <p class="m-0 text-sm font-semibold text-primary">Video approved</p>
              <p class="m-0 mt-1 text-xs text-secondary">
                Post this video on {{ getSocialChannelLabel(resolvedPlatform()) }}.
              </p>
              @if (platformHandle(); as handle) {
                <p class="m-0 mt-2 text-xs font-medium text-accent">@{{ handle }}</p>
              }
            </div>
          </div>

          <div class="flex flex-col gap-3">
            @if (mode() === 'primary') {
              @if (canUseTikTokSelector(video.id)) {
                <ins-creator-select-post-tiktok
                  [tiktokAccountId]="creator().ssCreator!.tiktokAccountId!"
                  [appVid]="video"
                  (selectedPost)="onSelectedPost($event)" />
              } @else if (canUseInstagramSelector(video.id)) {
                <ins-creator-select-post-instagram
                  [instagramAccountId]="creator().ssCreator!.instagramAccountId!"
                  [appVid]="video"
                  (selectedPost)="onSelectedPost($event)" />
              } @else if (selectedPreview(video.id); as preview) {
                <div>
                  @if (preview.cover_image_url || preview.thumbnail_url) {
                    <img
                      [src]="preview.cover_image_url || preview.thumbnail_url"
                      [alt]="preview.title || 'Selected post'"
                      class="aspect-[10/7] w-full rounded-lg object-cover" />
                  }
                  <p class="m-0 mt-2 truncate text-sm text-primary">{{ preview.title }}</p>
                </div>
              } @else {
                <div class="rounded-lg border border-dashed border-border p-4 text-center">
                  <p class="m-0 text-sm font-medium text-primary">Find a post</p>
                  <p class="m-0 mt-1 text-xs text-secondary">
                    Select a post from the creator's {{ getSocialChannelLabel(resolvedPlatform()) }} channel.
                  </p>
                  @if (
                    resolvedPlatform() === SocialChannelEnum['TikTok Post'] ||
                    resolvedPlatform() === SocialChannelEnum['Instagram Reel'] ||
                    resolvedPlatform() === SocialChannelEnum['Instagram Story']
                  ) {
                    <button
                      type="button"
                      class="primary-button mt-4"
                      (click)="openPostSelector(video.id)">
                      Select post
                    </button>
                  }
                </div>
              }
            }

            <label class="block text-sm">
              <span class="font-medium text-secondary">{{ getSocialChannelLabel(resolvedPlatform()) }} link</span>
              <input
                type="url"
                class="mt-1 block w-full rounded-lg border border-border bg-surface px-3 py-2 text-sm text-primary"
                [value]="getLinkValue(video.id)"
                (input)="updateLinkValue(video.id, $any($event.target).value)"
                placeholder="Video link" />
            </label>

            @if (requiresAdCode()) {
              <label class="block text-sm">
                <span class="font-medium text-secondary">Ad code</span>
                <input
                  type="text"
                  class="mt-1 block w-full rounded-lg border border-border bg-surface px-3 py-2 text-sm text-primary"
                  [value]="getAdCodeValue(video.id)"
                  [disabled]="isSubmitted(video.id)"
                  (input)="updateAdCodeValue(video.id, $any($event.target).value)"
                  placeholder="Ad code" />
              </label>
            }

            <div class="flex justify-end gap-2">
              @if (isSubmitted(video.id)) {
                <span
                  class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20">
                  Submitted
                </span>
              }
              <button
                type="button"
                class="primary-button disabled:opacity-50"
                [disabled]="submittingVideoId() === video.id || isSubmitted(video.id)"
                (click)="submitSocialPost(video.id)">
                @if (submittingVideoId() === video.id) {
                  Submitting…
                } @else {
                  Submit
                }
              </button>
            </div>
          </div>
        </li>
      }
    </ul>
  }
</ins-creator-action-panel>
